import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { COD_WALLET } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @muhammedburakak
 */

const CODWalletList = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},

			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				width: 150,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'codReportID',
				accessor: 'codReportId',
				filterType: FilterType.number,
				width: 70,
				showCopyButton: true
			},

			{
				Header: 'transactionType',
				accessor: 'transactionType',
				filterType: FilterType.multiSelection,
				width: 130
			},
			{
				Header: 'transferredAmount',
				accessor: 'transferredAmount',
				filterType: FilterType.float,
				width: 80,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'remainingAmount',
				accessor: 'remainingAmount',
				filterType: FilterType.float,
				width: 110,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'requestedAmount',
				accessor: 'requestedAmount',
				filterType: FilterType.float,
				width: 80,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'periodStartDate',
				accessor: 'periodStartDate',
				filterType: FilterType.date,
				width: 80,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'periodEndDate',
				accessor: 'periodEndDate',
				filterType: FilterType.date,
				width: 80,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.multiSelection,
				width: 100
			},
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.multiSelection,
				width: 130,
				showOnMobile: true
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);
	return (
		<div>
			<DynamicList
				id={DYNAMICLISTS.COD_WALLET_LIST}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={COD_WALLET.GET_COD_DASHBOARD_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="CODWalletList"
			/>
		</div>
	);
};

export default CODWalletList;
